const en = {
  hyrule: {
    general: {
      update: 'Update',
      close: 'Close'
    },
    forbidden: 'This page does not exist or you do not have the correct permissions to view this page.',
    logIn: {
      notLoggedIn: 'You are currently not logged in.',
      title: 'Login',
      out: 'Logout'
    },
    userProfile: {
      title: 'User Profile',
      edit: 'Edit Profile',
      name: 'Name',
      username: 'User Name',
      regionalOffice: 'Regional Office',
      preferredLanguage: 'Preferred Language',
      timezone: 'Timezone'
    }
  }
};
export default en;